import React, { Component } from 'react';
import { Translate } from '$common';



export default class ImageCapture extends Component {
  static type = 'image_capture';
  static elementName = Translate.get('image_capture');
  static icon = 'camera';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/image-capture.js